import script from "./GlobalFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalFooter.vue?vue&type=script&setup=true&lang=js"

import "./GlobalFooter.vue?vue&type=style&index=0&id=173b3022&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-173b3022"]])

export default __exports__